<script lang="ts" setup>
const props = withDefaults(defineProps<{
  components: any[]
  firstHeading?: boolean
}>(), {
  firstHeading: true,
});

const templates: any = {
  'carousel-block': defineAsyncComponent(() => import('./BlockCarousel.vue')),
  'categories-block': defineAsyncComponent(() => import('./BlockCategories.vue')),
  'products-block': defineAsyncComponent(() => import('./BlockProducts.vue')),
  'features-block': defineAsyncComponent(() => import('./BlockFeatures.vue')),
  'categoryproducts-block': defineAsyncComponent(() => import('./BlockCategoryProducts.vue')),
  'offer-block': defineAsyncComponent(() => import('./promo/BlockOffer.vue')),
  'faqs-block': defineAsyncComponent(() => import('./promo/BlockFaq.vue')),
  'textimage-block': defineAsyncComponent(() => import('./promo/BlockImageText.vue')),
  'text-block': defineAsyncComponent(() => import('./promo/BlockText.vue')),
  'cards-block': defineAsyncComponent(() => import('./BlockCards.vue')),
  'brandsslider-block': defineAsyncComponent(() => import('./BlockBrandsSlider.vue')),
  'brandsstatic-block': defineAsyncComponent(() => import('./BlockBrandsStatic.vue')),
  'topproduct-block': defineAsyncComponent(() => import('./BlockTopProduct.vue')),
  'topcategory-block': defineAsyncComponent(() => import('./BlockTopCategory.vue')),
}
</script>

<template>
  <template v-for="(component, i) in components" :key="component.id ?? i">
    <div v-if="component.__typename === 'CkeditorMarkup'" class="prose max-w-none" v-html="component.html"></div>
    <component
      v-else-if="templates[component.__typename]"
      :is="templates[component.__typename]"
      v-bind="component"
      :first="props.firstHeading && i === 0 && component.__typename === 'text-block'"
    />
  </template>
</template>
